import React, { useState } from "react";

// Editable version of the planner's Spec (backend/app/planner.py).
function ChipList({ items, prefix, onChange, placeholder }) {
  const [draft, setDraft] = useState("");
  const add = () => {
    const parts = draft
      .split(",")
      .map((t) => (prefix === "#" ? t.trim().replace(/^#/, "") : t.trim()))
      .filter(Boolean);
    if (parts.length) onChange([...items, ...parts.filter((p) => !items.includes(p))]);
    setDraft("");
  };
  return (
    <div className="chiplist">
      {items.map((t) => (
        <span key={t} className="chip edit">
          {prefix === "#" ? `#${t}` : `"${t}"`}
          <button type="button" aria-label={`remove ${t}`} onClick={() => onChange(items.filter((x) => x !== t))}>
            ×
          </button>
        </span>
      ))}
      <input
        className="chip-input"
        value={draft}
        placeholder={placeholder}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            add();
          }
        }}
        onBlur={add}
      />
    </div>
  );
}

const num = (v) => (v === "" || v == null ? null : Number(v));

export default function PlanEditor({ spec, onChange }) {
  const set = (k, v) => onChange({ ...spec, [k]: v });
  const numField = (k, label) => (
    <label className="sf-num">
      <span className="sf-label">{label}</span>
      <input type="number" min={0} value={spec[k] ?? ""} placeholder="any" onChange={(e) => set(k, num(e.target.value))} />
    </label>
  );
  return (
    <div className="plan">
      <div className="plan-row">
        <span className="spec-k">niche</span>
        <textarea rows={2} value={spec.niche} onChange={(e) => set("niche", e.target.value)} />
      </div>
      <div className="plan-row">
        <span className="spec-k">location</span>
        <input value={spec.location} placeholder="anywhere" onChange={(e) => set("location", e.target.value)} />
      </div>
      <div className="plan-row">
        <span className="spec-k">judge criteria</span>
        <textarea rows={3} value={spec.criteria} onChange={(e) => set("criteria", e.target.value)} />
      </div>
      <div className="plan-row">
        <span className="spec-k">hard filters</span>
        <div className="sf-stop">
          {numField("min_followers", "Min followers")}
          {numField("max_followers", "Max followers")}
          {numField("min_posts", "Min posts")}
          {numField("max_posts", "Max posts")}
          <label className="sf-bool">
            <input type="checkbox" checked={!!spec.verified_only} onChange={(e) => set("verified_only", e.target.checked)} />
            <span>Verified only</span>
          </label>
        </div>
      </div>
      <div className="plan-row">
        <span className="spec-k">keywords</span>
        <ChipList
          items={spec.search_terms}
          prefix='"'
          placeholder="add keyword, Enter"
          onChange={(v) => set("search_terms", v)}
        />
      </div>
      <div className="plan-row">
        <span className="spec-k">hashtags</span>
        <ChipList items={spec.hashtags} prefix="#" placeholder="add hashtag, Enter" onChange={(v) => set("hashtags", v)} />
      </div>
      <p className="muted plan-note">
        These seed round 1. Later rounds add their own keywords and hashtags from what worked.
      </p>
    </div>
  );
}
